import React, { useState } from "react";
import Header from "./components/Header";
import About from "./components/About";
import Skills from "./components/Skills";
import Experiences from "./components/Experiences";
import Education from "./components/Education";
import Interests from "./components/Interests";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Portfolio from "./components/Portfolio";
import SidebarTabs from "./components/SidebarTabs";
import {
  FaUser,
  FaTools,
  FaBriefcase,
  FaGraduationCap,
  FaHeart,
  FaEnvelope,
  FaImages,
} from "react-icons/fa";
import "./App.css";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
// Tableau unique avec icône ET composant
const TABS = [
  { id: "about", label: "À propos", icon: <FaUser />, component: <About /> },
  {
    id: "skills",
    label: "Compétences",
    icon: <FaTools />,
    component: <Skills />,
  },
  {
    id: "experiences",
    label: "Expériences",
    icon: <FaBriefcase />,
    component: <Experiences />,
  },
  {
    id: "portfolio",
    label: "Portfolio",
    icon: <FaImages />,
    component: <Portfolio />,
  },
  {
    id: "education",
    label: "Formations",
    icon: <FaGraduationCap />,
    component: <Education />,
  },
  {
    id: "interests",
    label: "Centres d'intérêt",
    icon: <FaHeart />,
    component: <Interests />,
  },
  {
    id: "contact",
    label: "Contact",
    icon: <FaEnvelope />,
    component: <Contact />,
  },
];

function App() {
  const [activeTab, setActiveTab] = useState("about");
  const currentTab = TABS.find((tab) => tab.id === activeTab);

  return (
    <div className="tab-app-layout">
      <Header />
      <div className="tab-body-layout">
        <SidebarTabs
          tabs={TABS}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <main className="tab-main-content">
          <div className="tab-content">{currentTab.component}</div>
        </main>
      </div>
      <Analytics />
      <SpeedInsights />
      <Footer />
    </div>
  );
}

export default App;
